export enum ESortTypes {
	date,
	name,
	discount,
}